let active = false
const root = document.documentElement
const toggler = document.getElementById('nav-toggle')
const wrap = document.querySelector('.sp-nav-wrap')

toggler.addEventListener('click', () => setActive(!active))
wrap.addEventListener('click', () => setActive(false))

function setActive (aActive) {
	active = aActive
	root.classList[active ? 'add' : 'remove']('js-sp-nav-active')
}
